import { postCrq } from 'AppSrc/core/crq/crq-queries';
import {
  getCrqParametersFromFormDataAndUser,
  getCrqParametersFromFormDataAndUserChangeAnalyst,
  getCrqParametersFromFormDataAndUserAssignToMe,
  getCrqParametersFromFormDataRemedyRef,
} from 'AppSrc/core/components/forms/form-types/create-crq/get-create-crq-parameters';
import {
  getCrqWIIParamsFromFormDataAndUser,
} from 'AppSrc/core/components/forms/form-types/create-crq/get-work-info-item-parameters';
import { FIXED, MOBILE } from 'AppSrc/core/components/forms/value-dependency-constants';
import {
  VIEWING_CRQ,
  // ES_VIEWING_NEW_SECTION,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { createWorkInfoItemsForCRQ } from 'AppSrc/core/work-info-items/work-info-item-actions';
import { setSponsorForCrq } from 'AppSrc/core//sponsor/sponsor-actions';
import { updateCrqRelationships } from 'AppSrc/core/relationships/relationships-actions';
import { getUnsavedRelationships } from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-section-logic';
// import { getUnsavedApproverGroups, getSavedApproverGroups } from 'AppSrc/core/components/forms/form-types/create-crq/approvers-section/approvers-section-logic';
import {
  getUnsavedApproverGroups,
  getUnsavedApproverGroupsOlo,
  getSavedApproverGroups,
  getUnsavedApproverGroupsEmergency,
} from 'AppSrc/core/components/forms/form-types/create-crq/approvers-section/approvers-section-logic';
import { addApproverGroupsToCrq } from 'AppSrc/core/approvers/approver-groups-actions';
import { individualAddApproverGroupsToCrq } from 'AppSrc/core/crq/crq-list-actions';
import { shouldStatusTransitionSkipPostCrq } from 'AppSrc/core/crq/crq-status-transitions';
import { getIsOlaCrq, isCrqEmergency } from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { addSignatures } from 'AppSrc/core/approvers/approvals-queries';
import {
  submitEditFormRequest,
  submitEditFormSuccess,
  submitEditFormError,
  // fetchCrqForViewEdit,
} from './actions-edit-form';


// thunk action to collect the CRQ form data based on an existingCrqId and submit to the endpoint
const updateEditCrqWithId = (existingCrqId, statusTransition, selectedReason, isPostponeReason, isShowCrqAction, ispostponeReason1, ispostponeReason2, ispostponeReason3, postponeStatus, postponeStatusReason, mobilePostponeStatusReason) => (dispatch, getState) => {
  const formData = getState().editForm.formDataById[existingCrqId];
  const user = getState().auth.user;
  const newStatus = statusTransition ? statusTransition.targetStatus : null;
  const crqParams = getCrqParametersFromFormDataAndUser(formData, user, newStatus, selectedReason, isPostponeReason, isShowCrqAction, ispostponeReason1, ispostponeReason2, ispostponeReason3, postponeStatus, postponeStatusReason, mobilePostponeStatusReason);
  const network = crqParams.network;
  const isEmergency = isCrqEmergency(formData);
  // don't call postCrq if the status transition should skip post
  const shouldPostCrq = !shouldStatusTransitionSkipPostCrq(statusTransition);
  dispatch(submitEditFormRequest(existingCrqId, 'firstsubmit'));


  // const value = window.localStorage.getItem('statusReason');
  // dispatch(submitEditFormRequest(existingCrqId, 'firstsubmit'));
  // let approverGroups = [];
  // if ((crqParams.status === 'Planning In Progress') && (formData.riskValue === 'Risk Level 3' || formData.riskValue === 'Risk Level 4')) {
  //   approverGroups = ['Mobile Communications Check']; // since we were getting undefined approver group here, hence hardcoded for passing group id when defined.
  // }
  // dispatch(addApproverGroupsToCrq({
  //   formData,
  //   approverGroups,
  // }));
  // initial promise should be posting crq, unless `shouldPostCrq` is false
  // in which case we make a promise that immediately resolves
  const promise = shouldPostCrq ? postCrq(crqParams, existingCrqId) : Promise.resolve(true);
  return promise
    .then(
      // get the work info items out of formData and user
      () => (
        getCrqWIIParamsFromFormDataAndUser({
          formData,
          user,
          statusTransition,
        })
          .then(
            (workInfoItemParams) => {
              if (crqParams.status !== '5' && (crqParams.impact === '3000' || crqParams.impact === '4000')) {
                dispatch(createWorkInfoItemsForCRQ(existingCrqId, workInfoItemParams));
              }
              // if (crqParams.status !== '5' && (crqParams.impact === '1000' || crqParams.impact === '2000') && workInfoItemParams.length > '6') {
              //   dispatch(createWorkInfoItemsForCRQ(existingCrqId, workInfoItemParams));
              // }
              // To avoid multiple wii api calls for impact 1 & 2 during revoking, hence restricting here.
              if ((crqParams.status !== '10' && crqParams.status !== '5') && (crqParams.impact === '1000' || crqParams.impact === '2000')) {
                dispatch(createWorkInfoItemsForCRQ(existingCrqId, workInfoItemParams));
              }
              if (network === FIXED && crqParams.status === '5') {
                if (statusTransition.id === 'REVOKE_APPROVAL') {
                  dispatch(createWorkInfoItemsForCRQ(existingCrqId, workInfoItemParams));
                }
              }
              if (network === 'mobile') {
                dispatch(createWorkInfoItemsForCRQ(existingCrqId, workInfoItemParams));
              }
            },
          )
      ),
    )
    .then(() => {
      const sponsor = formData.unsavedSponsorValue;
      // if there is no new sponsor value to save to the endpoint
      // move on to the next `then`
      if (!sponsor) {
        return true;
      }
      return dispatch(setSponsorForCrq({
        crqId: existingCrqId,
        network,
        sponsor,
      }));
    })
    .then((crqId) => {
      let approverGroups = network === FIXED ? getUnsavedApproverGroups(formData) : [];
      const individualApprovers = getState().individualApproverList.ApproversList;
      // approverGroups = ['Mobile Communications Check'];
      // if there are no unsaved approver groups
      // move on to the next `then`
      // Approver Groups set thrugh sessionstorage to false the section error of Approvers section
      // const OLOCrq = getIsOlaCrq(formData);
      const changeDetails = 'CHANGE_DETAILS';
      const isOloByService = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
      const OLOCrq = getIsOlaCrq(formData) || isOloByService;

      if (OLOCrq && crqParams.status === '4') {
        approverGroups = getUnsavedApproverGroupsOlo;
      }
      if (individualApprovers.length > 0) {
        dispatch(individualAddApproverGroupsToCrq(network, existingCrqId, individualApprovers));
      }
      if (!approverGroups || approverGroups.length === 0) {
        return crqId;
      }
      if (approverGroups.length > 0) {
        window.sessionStorage.setItem('isApproverAdded', true);
      }
      return dispatch(addApproverGroupsToCrq({
        formData,
        approverGroups,
        formFlow: VIEWING_CRQ,
      }));
    })
    .then(() => {
      const unsavedRelationships = network === MOBILE ? getUnsavedRelationships(formData) : [];
      if (!unsavedRelationships || unsavedRelationships.length === 0) {
        // if there are no values to save move on to next then
        return true;
      }
      return dispatch(updateCrqRelationships({
        crqId: existingCrqId,
        unsavedRelationships,
        formFlow: VIEWING_CRQ,
      }));
    })
    .then(() => {
      let approverGroups = [];
      const SavedApprovers = getSavedApproverGroups(formData);
      const commsSelection = network === MOBILE ? formData.dataByFormSectionId.CHANGE_DETAILS.dataByFieldId.comms_required.value[0] : '';

      // here we can add mobile comm check group to emergency CRQs
      if ((formData.status === '3' && newStatus === '4') && (formData.riskValue === 'Risk Level 3' || formData.riskValue === 'Risk Level 4') && commsSelection === 'Yes') {
        approverGroups = SavedApprovers === true ? [] : ['Mobile Communications Check']; // since we were getting undefined approver group here, hence hardcoded for passing group id when defined.
      }
      if ((formData.status === '3' && newStatus === '4') && (formData.riskValue === 'Risk Level 1' || formData.riskValue === 'Risk Level 2') && commsSelection === 'Yes' && isEmergency) {
        approverGroups = SavedApprovers === true ? [] : ['Mobile Communications Check']; // since we were getting undefined approver group here, hence hardcoded for passing group id when defined.
      }
      // Emergency block impact 3 & 4
      if ((formData.status === '3') && ((crqParams.impact === '3000' || crqParams.impact === '4000')) && isEmergency) {
        approverGroups = [...approverGroups, ...getUnsavedApproverGroupsEmergency];
      }
      dispatch(addApproverGroupsToCrq({
        formData,
        approverGroups,
      }));
    })
    .then(
      (crqId) => {
        dispatch(submitEditFormSuccess(existingCrqId));
        // dispatch(submitEditFormSuccess(existingCrqId));
        // might need to do something with this
        return ({
          success: true,
          formData,
          crqId,
        });
      },
    )
    .catch((error) => {
      dispatch(submitEditFormError(existingCrqId, error));
      return Promise.reject(error);
    });
};

const updateEditCrqWithIdChangeAnalyst = (existingCrqId, statusTransition, selectedReason, isPostponeReason, isShowCrqAction, ispostponeReason1, ispostponeReason2, ispostponeReason3, postponeStatus, postponeStatusReason, mobilePostponeStatusReason) => (dispatch, getState) => {
  const formData = getState().editForm.formDataById[existingCrqId];
  const user = getState().auth.user;
  const newStatus = statusTransition ? statusTransition.targetStatus : null;
  const crqParams = getCrqParametersFromFormDataAndUserChangeAnalyst(formData, user, newStatus, selectedReason, isPostponeReason, isShowCrqAction, ispostponeReason1, ispostponeReason2, ispostponeReason3, postponeStatus, postponeStatusReason, mobilePostponeStatusReason);
  const network = crqParams.network;
  // don't call postCrq if the status transition should skip post
  const shouldPostCrq = !shouldStatusTransitionSkipPostCrq(statusTransition);
  dispatch(submitEditFormRequest(existingCrqId));
  // initial promise should be posting crq, unless `shouldPostCrq` is false
  // in which case we make a promise that immediately resolves
  const promise = shouldPostCrq ? postCrq(crqParams, existingCrqId) : Promise.resolve(true);
  return promise
    .then(
      // get the work info items out of formData and user
      () => (
        getCrqWIIParamsFromFormDataAndUser({
          formData,
          user,
          statusTransition,
        })
          .then(
            (workInfoItemParams) => {
              // if (crqParams.status !== '5' && workInfoItemParams.length > '6') {
              //   dispatch(createWorkInfoItemsForCRQ(existingCrqId, workInfoItemParams));
              // }
              if (crqParams.status !== '5' && (crqParams.impact === '1000' || crqParams.impact === '2000')) {
                dispatch(createWorkInfoItemsForCRQ(existingCrqId, workInfoItemParams));
              }
            },
          )
      ),
    )
    .then(() => {
      const sponsor = formData.unsavedSponsorValue;
      // if there is no new sponsor value to save to the endpoint
      // move on to the next `then`
      if (!sponsor) {
        return true;
      }
      return dispatch(setSponsorForCrq({
        crqId: existingCrqId,
        network,
        sponsor,
      }));
    })
    .then((crqId) => {
      const approverGroups = network === FIXED ? getUnsavedApproverGroups(formData) : [];
      // if there are no unsaved approver groups
      // move on to the next `then`
      if (!approverGroups || approverGroups.length === 0) {
        return crqId;
      }
      return dispatch(addApproverGroupsToCrq({
        formData,
        approverGroups,
        formFlow: VIEWING_CRQ,
      }));
    })
    .then(() => {
      const unsavedRelationships = network === MOBILE ? getUnsavedRelationships(formData) : [];
      if (!unsavedRelationships || unsavedRelationships.length === 0) {
        // if there are no values to save move on to next then
        return true;
      }
      return dispatch(updateCrqRelationships({
        crqId: existingCrqId,
        unsavedRelationships,
        formFlow: VIEWING_CRQ,
      }));
    })
    .then(
      () => {
        dispatch(submitEditFormSuccess(existingCrqId));
        // might need to do something with this
        return ({
          success: true,
          formData,
        });
      },
    )
    .catch((error) => {
      dispatch(submitEditFormError(existingCrqId, error));
      return Promise.reject(error);
    });
};

const updateEditCrqWithIdAssignToMe = (existingCrqId, isAssign, reAssigneId, statusTransition, selectedReason, isPostponeReason, isShowCrqAction, ispostponeReason1, ispostponeReason2, ispostponeReason3, postponeStatus, postponeStatusReason, mobilePostponeStatusReason) => (dispatch, getState) => {
  const formData = getState().editForm.formDataById[existingCrqId];
  const user = getState().auth.user;
  const newStatus = statusTransition ? statusTransition.targetStatus : null;
  const isAssignTrue = isAssign;
  const newReAssigneId = reAssigneId;
  // pass reAssign ID to func
  const crqParams = getCrqParametersFromFormDataAndUserAssignToMe(formData, user, newStatus, isAssignTrue, newReAssigneId, selectedReason, isPostponeReason, isShowCrqAction, ispostponeReason1, ispostponeReason2, ispostponeReason3, postponeStatus, postponeStatusReason, mobilePostponeStatusReason);
  const network = crqParams.network;
  // don't call postCrq if the status transition should skip post
  const shouldPostCrq = !shouldStatusTransitionSkipPostCrq(statusTransition);
  dispatch(submitEditFormRequest(existingCrqId));
  // initial promise should be posting crq, unless `shouldPostCrq` is false
  // in which case we make a promise that immediately resolves
  const promise = shouldPostCrq ? postCrq(crqParams, existingCrqId) : Promise.resolve(true);
  return promise
    // .then(
    //   // get the work info items out of formData and user
    //   () => (
    //     getCrqWIIParamsFromFormDataAndUser({
    //       formData,
    //       user,
    //       statusTransition,
    //     })
    //       .then(
    //         (workInfoItemParams) => dispatch(createWorkInfoItemsForCRQ(existingCrqId, workInfoItemParams)),
    //       )
    //   ),
    // )
    .then(() => {
      const sponsor = formData.unsavedSponsorValue;
      // if there is no new sponsor value to save to the endpoint
      // move on to the next `then`
      if (!sponsor) {
        return true;
      }
      return dispatch(setSponsorForCrq({
        crqId: existingCrqId,
        network,
        sponsor,
      }));
    })
    .then((crqId) => {
      const approverGroups = network === FIXED ? getUnsavedApproverGroups(formData) : [];
      // if there are no unsaved approver groups
      // move on to the next `then`
      if (!approverGroups || approverGroups.length === 0) {
        return crqId;
      }
      return dispatch(addApproverGroupsToCrq({
        formData,
        approverGroups,
        formFlow: VIEWING_CRQ,
      }));
    })
    .then(() => {
      const unsavedRelationships = network === MOBILE ? getUnsavedRelationships(formData) : [];
      if (!unsavedRelationships || unsavedRelationships.length === 0) {
        // if there are no values to save move on to next then
        return true;
      }
      return dispatch(updateCrqRelationships({
        crqId: existingCrqId,
        unsavedRelationships,
        formFlow: VIEWING_CRQ,
      }));
    })
    .then(
      () => {
        dispatch(submitEditFormSuccess(existingCrqId));
        // might need to do something with this
        return ({
          success: true,
          formData,
        });
      },
    )
    .catch((error) => {
      dispatch(submitEditFormError(existingCrqId, error));
      return Promise.reject(error);
    });
};

// Approval assignment method
const updateEditCrqWithIdAssignApproval = (approvalSigntures) => (dispatch, getState) => {
  const shouldPostCrq = true;
  const promise = shouldPostCrq ? addSignatures(approvalSigntures) : Promise.resolve(false);
  return promise;
};

// This is for adding additional approver from SFA stage i.e status 5.
const addAdditionalApproversFromViewCrq = (crqId) => (dispatch, getState) => {
  const formData = getState().editForm.formDataById[crqId];
  const network = formData.dataByFormSectionId.CHANGE_TYPE.dataByFieldId.select_network.displayValues[0].value;
  // const approverGroups = getUnsavedApproverGroups(formData);
  let approverGroups = network === FIXED ? getUnsavedApproverGroups(formData) : [];
  const individualApprovers = getState().individualApproverList.ApproversList;
  // if there are no unsaved approver groups, return a promise
  // if (!approverGroups || approverGroups.length === 0) {
  //   // return a promise indicating that the modal should close
  //   return Promise.resolve({ shouldClose: true });
  // }
  // const OLOCrq = getIsOlaCrq(formData);
  const changeDetails = 'CHANGE_DETAILS';
  const isOloByService = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
  const OLOCrq = getIsOlaCrq(formData) || isOloByService;


  if (OLOCrq && formData.status === '4') {
    approverGroups = getUnsavedApproverGroupsOlo;
  }
  if (individualApprovers.length > 0) {
    dispatch(individualAddApproverGroupsToCrq(network, crqId, individualApprovers));
  }
  // if (!approverGroups || approverGroups.length === 0) {
  //   return crqId;
  // }
  return dispatch(addApproverGroupsToCrq({
    formData,
    approverGroups,
    formFlow: VIEWING_CRQ,
  }));
  // .then(() => {
  //   // after successful add, refetch the crq
  //   dispatch(fetchCrqForViewEdit({
  //     editingStatus: ES_VIEWING_NEW_SECTION,
  //     crqId,
  //     network,
  //   }));
  //   // return a promise indicating that the modal should not close
  //   // this is because the fetch will remount the entire page
  //   // and the state change would be a no-op and lead to a warning.
  //   // return Promise.resolve({ shouldClose: false });
  // });
};

// This is for cancelling the approvals granted to the CRQ, this functionality will re-add the same approver to the CRQ.
const revokeApproversFromViewCrq = (network, crqId, revokeGroupArray, individualIdArray) => (dispatch, getState) => {
  const formData = getState().editForm.formDataById[crqId];
  // const approverGroups = getUnsavedApproverGroups(formData);
  const approverGroups = [];
  const individualApprovers = [];

  // const OLOCrq = getIsOlaCrq(formData);
  // if (OLOCrq && formData.status === '4') {
  //   approverGroups = getUnsavedApproverGroupsOlo;
  // }

  if (revokeGroupArray !== undefined) {
    approverGroups.push(revokeGroupArray);
  }

  if (individualIdArray.email !== null) {
    individualApprovers.push(individualIdArray);
  }

  if (individualIdArray.email !== null && revokeGroupArray.id === null) {
    return dispatch(individualAddApproverGroupsToCrq(network, crqId, individualApprovers));
  }
  return dispatch(addApproverGroupsToCrq({
    formData,
    approverGroups,
    formFlow: VIEWING_CRQ,
  }));
};

// thunk action to collect the CRQ form data based on an existingCrqId and submit to the endpoint
const updateRemedyRefCrqWithId = (fixedCrqId, statusTransition, selectedReason, isRefPostponeReason) => (dispatch, getState) => {
  const formData = getState().remedyReferenceCrq.crqData;
  const formDataFixed = getState().editForm.formDataById[fixedCrqId];
  const existingCrqId = formData.crqId;
  const getRelCoordinatorId = getState().remedyReferenceCrq.selectedRelCordinator;
  // const newStatus = statusTransition ? statusTransition.targetStatus : null;
  // const crqParams = getCrqParametersFromFormDataAndUser(formData, user, newStatus);
  const crqParams = getCrqParametersFromFormDataRemedyRef(formData, formDataFixed, getRelCoordinatorId, statusTransition, selectedReason, isRefPostponeReason);

  // don't call postCrq if the status transition should skip post
  const shouldPostCrq = !shouldStatusTransitionSkipPostCrq(statusTransition);
  // dispatch(submitEditFormRequest(existingCrqId, 'firstsubmit'));

  // initial promise should be posting crq, unless `shouldPostCrq` is false
  // in which case we make a promise that immediately resolves
  const promise = shouldPostCrq ? postCrq(crqParams, existingCrqId) : Promise.resolve(true);
  return promise
    .catch((error) => {
      // dispatch(submitEditFormError(existingCrqId, error));
      console.log('error reuse REF');
      return Promise.reject(error);
    });
};

export {
  updateEditCrqWithId,
  addAdditionalApproversFromViewCrq,
  updateEditCrqWithIdChangeAnalyst,
  updateEditCrqWithIdAssignToMe,
  updateEditCrqWithIdAssignApproval,
  revokeApproversFromViewCrq,
  updateRemedyRefCrqWithId,
};

